import { createSlice } from "@reduxjs/toolkit";
import { POSReportsTypes } from "utils/types/POSReducer";

const labelValue = { label: "", value: "" };

// initial state
const initialState: POSReportsTypes = {
  selectedBranch: labelValue,
  selectedManager: labelValue,
  selectedSource: labelValue,
};

// ==============================|| SLICE - Date Picker ||============================== //

const posReports = createSlice({
  name: "posReports",
  initialState,
  reducers: {
    setSelectedBranch(state, action) {
      state.selectedBranch = action.payload;
    },
    setSelectedManager(state, action) {
      state.selectedManager = action.payload;
    },
    setSelectedSource(state, action) {
      state.selectedSource = action.payload;
    },
    resetPOSFilters(state) {
      state.selectedBranch = labelValue;
      state.selectedManager = labelValue;
      state.selectedSource = labelValue;
    },
  },
});

export default posReports.reducer;

export const {
  setSelectedBranch,
  setSelectedManager,
  setSelectedSource,
  resetPOSFilters,
} = posReports.actions;
